import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Carousel from 'react-bootstrap/Carousel'

import {Button} from  'react-bootstrap'
import {Link} from 'react-scroll'

import a1 from './asset/a1.jpeg';
import a2 from './asset/a2.jpeg';
import a3 from './asset/a3.jpeg';
import a5 from './asset/a5.jpeg';

const Home = () => {

    return (
        
        <div className="home" >
            <div className="col-lg-13 mr-auto text-center mb-5 mb-lg-0">
            
            <Carousel>
            <Carousel.Item>
                <img
                className="d-block w-100"
               
                src={a1}
                alt="First slide"
                />
                 <Carousel.Caption>
                <Link to="about"><Button className="btn-danger">Explore</Button></Link>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                className="d-block w-100"
                src={a3}
                alt="Third slide"
                /> <Carousel.Caption>
                <Link to="about"><Button className="btn-danger">Explore</Button></Link>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                className="d-block w-100"
                src={a2}
                alt="Third slide"
                />
                <Carousel.Caption>
                <Link to="about"><Button className="btn-danger">Explore</Button></Link>
                </Carousel.Caption>
              
            </Carousel.Item>

            <Carousel.Item>
                <img
                className="d-block w-100"
               
                src={a5}
                alt="First slide"
                />
                 <Carousel.Caption>
                <Link to="about"><Button className="btn-danger">Explore</Button></Link>
                </Carousel.Caption>
            </Carousel.Item>
           
            </Carousel>
            </div>        
            

            </div>
        

    );

}

export { Home };
